export const categories = [
  {
    id: 'slots',
    name: '电子游艺',
    slug: 'slots',
    description: '精彩纷呈的老虎机与电子游戏，炫目特效与超高赔率带来极致刺激体验',
    icon: 'ri-gamepad-line',
    gameCount: 128,
  },
  {
    id: 'live',
    name: '真人视讯',
    slug: 'live',
    description: '真人荷官实时互动，沉浸式赌场体验，多角度高清直播',
    icon: 'ri-live-line',
    gameCount: 56,
  },
  {
    id: 'sports',
    name: '体育电竞',
    slug: 'sports',
    description: '全球热门赛事全覆盖，实时赔率更新，专业电竞竞猜',
    icon: 'ri-football-line',
    gameCount: 89,
  },
  {
    id: 'lottery',
    name: '彩票游戏',
    slug: 'lottery',
    description: '官方开奖数据同步，多种玩法任选，小投入赢取大回报',
    icon: 'ri-ticket-line',
    gameCount: 42,
  },
  {
    id: 'fishing',
    name: '捕鱼游戏',
    slug: 'fishing',
    description: '3D深海捕鱼，多人同屏竞技，万倍炮台畅爽轰击',
    icon: 'ri-anchor-line',
    gameCount: 35,
  },
  {
    id: 'board',
    name: '棋牌游戏',
    slug: 'board',
    description: '经典棋牌对战，斗地主、炸金花、牛牛等热门玩法一应俱全',
    icon: 'ri-grid-line',
    gameCount: 67,
  },
  {
    id: 'arcade',
    name: '街机游戏',
    slug: 'arcade',
    description: '怀旧街机经典再现，水果机、奔驰宝马等童年回忆焕新登场',
    icon: 'ri-gamepad-line',
    gameCount: 44,
  },
  {
    id: 'new',
    name: '最新上架',
    slug: 'new',
    description: '每周更新精品新游，抢先体验最新游戏大作',
    icon: 'ri-sparkling-line',
    gameCount: 23,
  },
];

export const featuredGames = [
  {
    id: 1,
    name: '幸运777',
    category: '电子游艺',
    image: 'https://readdy.ai/api/search-image?query=Premium%20slot%20machine%20game%20interface%20with%20lucky%20seven%20theme%20and%20vibrant%20golden%20colors%2C%20luxurious%20dark%20background%20with%20warm%20highlights%2C%20gaming%20entertainment%20design%2C%20professional%20casino%20style&width=800&height=600&seq=game-lucky-777&orientation=landscape',
    rating: 4.9,
    players: 128500,
    label: '热门',
    description: '经典777老虎机全新升级，多重奖金线与免费旋转，大奖触手可及',
  },
  {
    id: 2,
    name: '龙虎争霸',
    category: '真人视讯',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20live%20casino%20dragon%20tiger%20game%20scene%20with%20professional%20dealer%20table%20and%20golden%20accents%2C%20luxurious%20dark%20background%2C%20warm%20ambient%20lighting%2C%20premium%20gaming%20atmosphere&width=800&height=600&seq=game-dragon-tiger&orientation=landscape',
    rating: 4.8,
    players: 96200,
    label: '推荐',
    description: '真人荷官专业发牌，高清流畅直播体验，龙虎对决精彩刺激',
  },
  {
    id: 3,
    name: '深海猎手',
    category: '捕鱼游戏',
    image: 'https://readdy.ai/api/search-image?query=Deep%20sea%20fishing%20game%20with%20colorful%20underwater%20creatures%20and%20coral%20reef%2C%20vibrant%20marine%20life%2C%20gaming%20interface%20with%20dark%20theme%20and%20neon%20accents%2C%20action%20packed%20design&width=800&height=600&seq=game-deep-sea&orientation=landscape',
    rating: 4.7,
    players: 85300,
    label: '新品',
    description: '3D深海场景震撼视觉，多人实时对战，万倍炮台火力全开',
  },
  {
    id: 4,
    name: '欧冠竞猜',
    category: '体育电竞',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20betting%20interface%20with%20football%20champions%20league%20theme%2C%20dark%20elegant%20background%20with%20gold%20and%20green%20accents%2C%20stadium%20atmosphere%2C%20premium%20design&width=800&height=600&seq=game-uefa&orientation=landscape',
    rating: 4.9,
    players: 156700,
    label: '热门',
    description: '欧洲冠军联赛全程竞猜，实时赔率更新，专业数据分析助力决策',
  },
  {
    id: 5,
    name: '财神到',
    category: '电子游艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fortune%20god%20themed%20slot%20game%20with%20red%20and%20gold%20traditional%20elements%2C%20lucky%20coins%20and%20ingots%2C%20festive%20design%2C%20dark%20luxurious%20background%2C%20warm%20lighting&width=800&height=600&seq=game-fortune&orientation=landscape',
    rating: 4.8,
    players: 112300,
    label: '推荐',
    description: '中国风主题老虎机，财神降临福气满满，丰厚彩金等你来拿',
  },
  {
    id: 6,
    name: '急速百家乐',
    category: '真人视讯',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20baccarat%20gaming%20table%20with%20professional%20casino%20dealer%2C%20dark%20elegant%20background%20with%20warm%20golden%20lighting%2C%20premium%20live%20casino%20experience%2C%20luxurious%20design&width=800&height=600&seq=game-baccarat&orientation=landscape',
    rating: 4.6,
    players: 78400,
    label: '新品',
    description: '极速百家乐新玩法，20秒一局快节奏，随时随地畅享赌场乐趣',
  },
  {
    id: 7,
    name: '欢乐斗地主',
    category: '棋牌游戏',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20card%20game%20doudizhu%20interface%20with%20playing%20cards%20and%20golden%20coins%2C%20dark%20elegant%20background%20with%20red%20accents%2C%20entertaining%20and%20vibrant%20design%2C%20modern%20game%20UI&width=800&height=600&seq=game-ddz&orientation=landscape',
    rating: 4.9,
    players: 201400,
    label: '热门',
    description: '国民级棋牌游戏，千万玩家在线对战，天天送欢乐豆',
  },
  {
    id: 8,
    name: '糖果派对',
    category: '街机游戏',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20candy%20themed%20arcade%20game%20with%20sweet%20vibrant%20visuals%2C%20pink%20and%20purple%20pastel%20colors%20on%20dark%20background%2C%20fun%20and%20playful%20design%2C%20modern%20mobile%20game%20aesthetic&width=800&height=600&seq=game-candy&orientation=landscape',
    rating: 4.7,
    players: 67200,
    label: '推荐',
    description: '甜蜜糖果主题街机，简单上手乐趣多，连消奖励停不下来',
  },
];

export const latestArticles = [
  {
    id: 1,
    slug: 'new-slot-game-2024',
    title: '2024年度最受欢迎老虎机游戏大盘点',
    excerpt: '盘点本年度最受玩家喜爱的十款老虎机游戏，从经典主题到创新玩法，每一款都值得一试。',
    category: '游戏资讯',
    author: '九游小编',
    date: '2024-12-15',
    image: 'https://readdy.ai/api/search-image?query=Gaming%20news%20article%20illustration%20with%20slot%20machine%20theme%2C%20luxurious%20dark%20background%20with%20golden%20highlights%2C%20professional%20editorial%20style%2C%20warm%20lighting%2C%20modern%20composition&width=800&height=600&seq=article-slots-2024&orientation=landscape',
    readTime: '8分钟',
    views: 23500,
    content: '',
  },
  {
    id: 2,
    slug: 'live-casino-guide',
    title: '真人视讯新手入门指南：从零开始的赌场体验',
    excerpt: '全面解析真人视讯游戏玩法规则、投注技巧和礼仪规范，帮助新手玩家快速上手，享受沉浸式赌场体验。',
    category: '新手指南',
    author: '九游小编',
    date: '2024-12-12',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20guide%20to%20live%20casino%20gaming%20with%20elegant%20dark%20theme%2C%20warm%20golden%20accents%2C%20professional%20gaming%20tutorial%20illustration%2C%20modern%20editorial%20design&width=800&height=600&seq=article-live-guide&orientation=landscape',
    readTime: '12分钟',
    views: 18900,
    content: '',
  },
  {
    id: 3,
    slug: 'christmas-promo-2024',
    title: '圣诞狂欢季！九游娱乐百万豪礼大放送',
    excerpt: '圣诞元旦双节同庆，九游娱乐推出超级福利活动，充值返利、免费旋转、实物奖品等你来拿！',
    category: '活动公告',
    author: '官方公告',
    date: '2024-12-10',
    image: 'https://readdy.ai/api/search-image?query=Christmas%20holiday%20promotion%20announcement%20illustration%20with%20festive%20golden%20and%20red%20elements%2C%20luxurious%20dark%20background%2C%20gift%20boxes%20and%20celebratory%20design%2C%20modern%20editorial%20style&width=800&height=600&seq=article-xmas-promo&orientation=landscape',
    readTime: '5分钟',
    views: 45200,
    content: '',
  },
  {
    id: 4,
    slug: 'sports-betting-strategy',
    title: '体育竞猜高手都在用的五个数据分析技巧',
    excerpt: '想要提高体育竞猜的胜率？掌握这些数据分析方法，让你的投注决策更加科学精准。',
    category: '游戏攻略',
    author: '九游小编',
    date: '2024-12-08',
    image: 'https://readdy.ai/api/search-image?query=Sports%20betting%20strategy%20and%20data%20analysis%20illustration%20with%20charts%20and%20stats%2C%20dark%20elegant%20background%20with%20green%20and%20gold%20accents%2C%20professional%20editorial%20design&width=800&height=600&seq=article-sports-tips&orientation=landscape',
    readTime: '10分钟',
    views: 32100,
    content: '',
  },
  {
    id: 5,
    slug: 'fishing-game-ranking',
    title: '捕鱼游戏战力排行榜：哪款捕鱼最值得玩？',
    excerpt: '对比市面上热门捕鱼游戏的画面、玩法、奖励机制，为你推荐最适合的捕鱼游戏。',
    category: '游戏资讯',
    author: '九游小编',
    date: '2024-12-05',
    image: 'https://readdy.ai/api/search-image?query=Fishing%20game%20ranking%20comparison%20illustration%20with%20underwater%20theme%2C%20colorful%20marine%20life%2C%20dark%20premium%20background%2C%20professional%20editorial%20design%2C%20vibrant%20visual&width=800&height=600&seq=article-fishing-rank&orientation=landscape',
    readTime: '7分钟',
    views: 16700,
    content: '',
  },
  {
    id: 6,
    slug: 'responsible-gaming',
    title: '理性游戏 快乐生活：九游娱乐责任博彩倡议',
    excerpt: '九游娱乐积极倡导责任博彩理念，为玩家提供自我管理工具和心理健康支持资源。',
    category: '平台公告',
    author: '官方公告',
    date: '2024-12-01',
    image: 'https://readdy.ai/api/search-image?query=Responsible%20gaming%20awareness%20illustration%20with%20calm%20and%20balanced%20design%2C%20dark%20elegant%20background%20with%20soft%20warm%20lighting%2C%20professional%20and%20trustworthy%20editorial%20style&width=800&height=600&seq=article-responsible&orientation=landscape',
    readTime: '6分钟',
    views: 8900,
    content: '',
  },
];

export const promotions = [
  {
    id: 1,
    title: '新人首存豪礼',
    subtitle: '首次充值100%返还',
    description: '新用户首次充值即可享受100%返还优惠，最高赠送888元游戏礼金！',
    icon: 'ri-gift-line',
    color: 'primary' as const,
  },
  {
    id: 2,
    title: '每日签到有礼',
    subtitle: '连续签到奖励翻倍',
    description: '每日签到领取免费金币，连续签到7天更有神秘大礼包等你来开启。',
    icon: 'ri-calendar-check-line',
    color: 'accent' as const,
  },
  {
    id: 3,
    title: 'VIP专属特权',
    subtitle: '尊享八大专属权益',
    description: '成为VIP会员享受专属客服、更高提现额度、生日礼金等八大特权。',
    icon: 'ri-vip-crown-line',
    color: 'accent' as const,
  },
  {
    id: 4,
    title: '邀请好友返利',
    subtitle: '邀请一位最高得200元',
    description: '邀请好友注册并充值，双方均可获得丰厚奖励，多邀多得无上限。',
    icon: 'ri-user-add-line',
    color: 'primary' as const,
  },
];

export const stats = [
  { value: '800万+', label: '注册用户', icon: 'ri-user-line' },
  { value: '2000+', label: '精品游戏', icon: 'ri-gamepad-line' },
  { value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line' },
  { value: '24/7', label: '客服在线', icon: 'ri-customer-service-line' },
];

export const testimonials = [
  {
    id: 1,
    name: '王先生',
    avatar: 'W',
    rating: 5,
    comment: '玩了两年多了，提现速度超快，客服态度也很好，真心推荐九游娱乐！',
    date: '2024-12-14',
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'L',
    rating: 5,
    comment: '最喜欢真人视讯板块，画面清晰流畅，荷官也很专业，体验完全不输线下赌场。',
    date: '2024-12-13',
  },
  {
    id: 3,
    name: '张先生',
    avatar: 'Z',
    rating: 5,
    comment: '朋友推荐来的，注册就送了礼金，运气好第一天就赢了不少，这个平台靠谱！',
    date: '2024-12-11',
  },
  {
    id: 4,
    name: '刘先生',
    avatar: 'L',
    rating: 4,
    comment: '游戏种类真的多，每天都有新游戏上架，完全不会玩腻，强烈推荐给各位玩家。',
    date: '2024-12-09',
  },
];